import { TemplateSettings } from '../store/interfaces';
import { BrandColors } from './brandColors';

export const defaultBranding: TemplateSettings = {
  requiresLogin: true,
  utilityBar: {
    backgroundColor: BrandColors.white,
    textColor: BrandColors.grey20,
    logo: null,
  },
  links: [
    {
      label: '',
      url: '',
    },
    {
      label: '',
      url: '',
    },
    {
      label: '',
      url: '',
    },
  ],
  footer: {
    backgroundColor: BrandColors.grey40,
    textColor: BrandColors.white,
    helpButton: {
      fillColor: BrandColors.white,
      outlineColor: BrandColors.grey40,
      textColor: BrandColors.grey40,
      text: 'Get Help',
    },
  },
  page: {
    containerColor: BrandColors.white,
    backgroundColor: BrandColors.white,
    backgroundImage: null,
    fontType: 'Open Sans',
    fontColor: BrandColors.grey20,
    buttonStyle1: {
      fillColor: BrandColors.grey20,
      outlineColor: BrandColors.grey20,
      textColor: BrandColors.white,
    },
    buttonStyle2: {
      fillColor: BrandColors.white,
      outlineColor: BrandColors.grey20,
      textColor: BrandColors.grey20,
    },
    timeline: {
      lineColor: BrandColors.lightGreenColor,
      iconContainerColor: BrandColors.white,
      iconColor: BrandColors.grey20,
    },
    flexibleBanner: false,
  },
};
